import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateModalComponent } from './template-modal/template-modal.component';
import { UIRouterModule } from '@uirouter/angular';
import { CATEGORY_STATES} from './template.states';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MaterialModule } from '../../material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ValidationModule } from '../../core/validation/validation.module';
import { TemplateOverviewComponent } from './template-overview/template-overview.component';
import {PagingModule} from "../../core/paging/paging.module";
import {SettingsModule} from "../settings/settings.module";

@NgModule({
  declarations: [
    TemplateOverviewComponent,
    TemplateModalComponent,
  ],
    imports: [
        CommonModule,
        UIRouterModule.forChild({states: CATEGORY_STATES}),
        TranslateModule.forChild({}),
        FontAwesomeModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        ValidationModule,
        PagingModule,
        SettingsModule,
    ],
})
export class TemplateModule {
}
